import { defineStore } from 'pinia';
import luaApi from '@/app/shared/services/lua-service';
import { useAlertStore } from '@/app/shared/stores/alert-store';
import { TreeItemNode } from '@/app/shared/types/tree/tree-item-node.interface';
import { LuaState } from '@/app/shared/types/tree/lua-state.interface';
import { Motif } from '@/app/shared/enums/motif-enum';

export const useLuaStore = defineStore('LuaStore', {
  state: () =>
    ({
      rawDataTreeItemNode: {},
    } as LuaState),

  getters: {
    getRawDataTreeItemNode(): TreeItemNode {
      return this.rawDataTreeItemNode;
    },
  },
  actions: {
    async fetchRawData(
      clientId: number,
      dataSourceName: string,
      segmentId: string
    ) {
      const alertStore = useAlertStore();
      try {
        const response = await luaApi.getLuaRawData(
          clientId,
          dataSourceName,
          segmentId
        );
        this.rawDataTreeItemNode = response.data.data;
      } catch (e) {
        const error: any = e;
        const message =
          error.errors?.[0].error || 'Unknown error returned from server';
        alertStore.showNotification(message, 'RawData', Motif.ERROR);
      }
    },
  },
});
